import { z } from 'zod';
import { DateSchema, ObjectIdSchema } from './base';

export const TrackerTagSchema = z.object({
  id: ObjectIdSchema,
  label: z.string(),
  trackerIds: z.array(ObjectIdSchema),
  color: z.string(),
  creatorId: ObjectIdSchema,
  editorIds: z.array(ObjectIdSchema),
  createdAt: DateSchema,
  updatedAt: DateSchema,
});

export type TrackerTag = z.infer<typeof TrackerTagSchema>;

export const TrackerTagPrototypeSchema = z.strictObject(
  TrackerTagSchema.pick({ label: true, trackerIds: true, color: true }).shape,
);

export type TrackerTagPrototype = z.infer<typeof TrackerTagPrototypeSchema>;

export const TrackerTagPatchSchema = z.strictObject(
  TrackerTagSchema.pick({ label: true, color: true, editorIds: true, creatorId: true }).partial()
    .shape,
);

export type TrackerTagPatch = z.infer<typeof TrackerTagPatchSchema>;
